import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { SelectItem } from 'primeng/api';
import { LayoutService } from './service/app.layout.service';
import {OverlayPanel} from "primeng/overlaypanel";
import {Subscription} from "rxjs";
import {AuthService} from "../services/auth.service";

@Component({
    selector: 'app-rightmenu',
    templateUrl: './app.rightmenu.component.html'
})
export class AppRightMenuComponent implements OnInit, OnDestroy{

    @ViewChild('op') overlayPanel: OverlayPanel | undefined;
    private subscription: Subscription | undefined;
    activeIndex: number = 4;
    userLoggedIn: boolean = false;
    constructor(public layoutService: LayoutService,
                public authService: AuthService) { }

    get visible(): boolean {
        return this.layoutService.state.rightMenuVisible;
    }

    set visible(_val: boolean) {
        this.layoutService.state.rightMenuVisible = _val;
    }
    ngOnInit(): void {
        // Suscríbete a los cambios de visibilidad del menú derecho y usa el evento
        this.subscription = this.layoutService.rightMenuVisibilityChange$.subscribe(event => {
            if (event) {
                this.overlayPanel?.show(event); // Muestra el OverlayPanel en la posición del clic
            }
        });
        this.isUserLoggedIn;
    }

    ngOnDestroy(): void {
        // Limpia la suscripción cuando el componente se destruya
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    navigateToLoginTab() {
        this.activeIndex = 4; // Cambia este índice al de la pestaña "Iniciar sesión"
    }
    // Método para comprobar si el usuario está autenticado
    get isUserLoggedIn(): boolean {
        this.userLoggedIn = this.authService.isLoggedIn();
        return this.userLoggedIn;
    }

    logout() {
        this.authService.logout();
    }
    openOverlay(event: Event) {
        if (this.overlayPanel) {
            this.overlayPanel.toggle(event);
        }
    }

}
